import { Outlet, useParams } from "react-router";
import NavMain from "./NavMain";
import ModalProvider from "../modal/ModalProvider";
import ExpandSidebar from "../toggleSidebar/ExpandSidebar";
import { useContext } from "react";
import ToggleSidebarContext from "../toggleSidebar/ToggleSidebarContext";
import $api from "../queries/openapi";
import { components } from "../ApiSchema";

export default function LayoutMain({
  user,
}: {
  user: components["schemas"]["LoggedInUserSchema"];
}) {
  const { collapseSidebar } = useContext(ToggleSidebarContext);

  const { teamSlug } = useParams();
  const { data: team, isFetched } = $api.useQuery(
    "get",
    "/api/teams/{team_slug}",
    { params: { path: { team_slug: teamSlug! } } },
    { enabled: !!teamSlug },
  );
  if (!isFetched) return null;

  return (
    <ModalProvider>
      <div className="fixed w-screen h-screen flex">
        {team ? (
          <>
            {collapseSidebar ? <ExpandSidebar /> : <NavMain user={user} />}
            <main className="h-full grow overflow-y-auto bg-slate-100">
              <Outlet />
            </main>
          </>
        ) : (
          <div className="grow items-center justify-center flex flex-col gap-4">
            <h1 className="text-2xl font-bold">Team Not Found</h1>
            <p className="text-slate-600">
              The team you are trying to access does not exist or has been
              deleted.
            </p>
          </div>
        )}
      </div>
    </ModalProvider>
  );
}
